export const UPDATE_COTACOES = 'UPDATE_COTACOES';
export const UPDATE_COTACOES_RAW = 'UPDATE_COTACOES_RAW';
export const UPDATE_COTACOES_LIST = 'UPDATE_COTACOES_LIST';
export const COTACOES_REQUESTED = 'COTACOES_REQUESTED';
export const COTACOES_RECEIVED = 'COTACOES_RECEIVED';
export const COTACOES_REQUEST_FAILED = 'COTACOES_REQUEST_FAILED';
export const COTACOES_INITIAL_REQUESTED = 'COTACOES_INITIAL_REQUESTED';
export const COTACOES_INITIAL_RECEIVED = 'COTACOES_INITIAL_RECEIVED';
